import React, {useEffect, useRef, useState} from "react";

export default function useDocumentTitle(title) {

  const documentTitle = useRef("Amira")

  useEffect(() => {
    if(title){
      documentTitle.current = title;
      document.title = title;
    }
  },[title]);

  return [documentTitle];
};